import { call, put, takeLatest } from "redux-saga/effects";
import { httpEditQuestion } from "../../../services/questions";
import {
  editQuestionStart,
  editQuestionSuccess,
  editQuestionFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* handleCreate({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpEditQuestion, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editQuestionSuccess(raw));
    successNotifier("Question edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editQuestionFailure(message || raw?.error));
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onEditQuestion() {
  yield takeLatest(editQuestionStart.type, handleCreate);
}
